module.exports = "<button\n\tclass='btn btn-default'\n\ton-click='@this.click(action(framework))'>\n\t{{framework}} {{display}}\n</button>";


//////////////////
// WEBPACK FOOTER
// ./src/ractive/components/views/event-button.html
// module id = 116
// module chunks = 0